import React from 'react';
import { Button } from '@avila-tek/ui/src';

function AssignModalButtons() {
  return (
    <div className="w-full flex space-x-5 mt-2">
      <Button className="bg-white border border-purple-300 text-purple-300">
        Cancelar
      </Button>
      <Button>Agregar al carrito</Button>
    </div>
  );
}

export default AssignModalButtons;
